import React from 'react';
import { Tag } from 'antd';
import type { UserStatus } from '../billingApi';

export const STATUS_META: Record<UserStatus, { label: string; color: string }> = {
  trial: { label: 'Trial', color: 'blue' },
  active: { label: 'Active', color: 'green' },
  past_due: { label: 'Payment failed', color: 'red' },
  cancelled: { label: 'Cancelled', color: 'orange' },
  locked: { label: 'Locked', color: 'default' },
  grant: { label: 'Free access', color: 'purple' },
};

export const StatusTag: React.FC<{ status: UserStatus }> = ({ status }) => {
  const meta = STATUS_META[status] ?? { label: status, color: 'default' };
  return <Tag color={meta.color}>{meta.label}</Tag>;
};
